import React from 'react';
import { Table, Button, Badge } from 'react-bootstrap';
import { FaEdit, FaTrash, FaEye } from 'react-icons/fa';

const CollectorTable = ({ collectors, onEdit, onDelete, onView }) => {
  if (!collectors || collectors.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-muted">No collectors found.</p>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <Table striped bordered hover size="sm">
        <thead className="table-dark">
          <tr>
            <th>SN</th>
            <th>Collector Name</th>
            <th>Mobile</th>
            <th>Assigned Labs</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {collectors.map((collector, index) => (
            <tr key={collector._id}>
              <td>{index + 1}</td>
              <td>{collector.name}</td>
              <td>{collector.mobile}</td>
              <td>
                {collector.assignedLabs && collector.assignedLabs.length > 0 ? (
                  <div>
                    {collector.assignedLabs.slice(0, 2).map(lab => (
                      <Badge key={lab._id} bg="secondary" className="me-1 mb-1">
                        {lab.name}
                      </Badge>
                    ))}
                    {collector.assignedLabs.length > 2 && (
                      <Badge bg="light" text="dark">
                        +{collector.assignedLabs.length - 2} more
                      </Badge>
                    )}
                  </div>
                ) : (
                  <span className="text-muted">No labs assigned</span>
                )}
              </td>
              <td>
                <Badge bg={collector.isActive ? 'success' : 'secondary'}>
                  {collector.isActive ? 'Active' : 'Inactive'}
                </Badge>
              </td>
              <td>
                <div className="d-flex gap-1">
                  {onView && (
                    <Button
                      variant="outline-info"
                      size="sm"
                      onClick={() => onView(collector)}
                      title="View Details"
                    >
                      <FaEye />
                    </Button>
                  )}
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => onEdit(collector)}
                    title="Edit Collector"
                  >
                    <FaEdit />
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => onDelete(collector)}
                    title="Delete Collector"
                  >
                    <FaTrash />
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default CollectorTable;
